<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Roberta J. Albrecht is a retired professor of English from Concordia College New York. Since retiring, she has become an independent scholar. Heretofore, her published work has been scholarly. (Both of her books were published by academic presses, and both have served as required texts for graduate seminars) This current volume is Albrecht’s first foray into a radically different field. Here, she ventures into that long-lived didactic tradition of the beast fable represented by such well-known authors as Aesop, Chaucer, Swift, and Orwell. Having lived in New York City for 23 years, she selects animals and animal-like characters that express the cruelty of city (and sometimes country) life. Her illustrations for these stories reinforce the text in that they express ways, both harsh and gentle, that animals (as people) face disappointment as they try to change their position in society. Hers is a courageous effort to reinvent the genre of beast fable.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0c6be6a0